import { OctopusPurpleLogo } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  url: string | null
}

export const WorkspaceAvatar: React.FC<Props> = ({ url }) => {
  if (!url) {
    return (
      <div className={css.avatar}>
        <OctopusPurpleLogo className={css.octopus} />
      </div>
    )
  }

  return (
    <div className={css.avatar}>
      <img className={css.img} src={url} alt="" />
    </div>
  )
}
